import React from 'react'
import 'react-dates/initialize';
import { Switch, Router } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { ToastContainer } from 'react-toastify'
import { connect } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { getUser } from 'store/auth/actions'

import history from 'services/browserHistory'
import MainLayoutRoute from './layouts/MainLayout/MainLayout'
import UnauthLayoutRoute from "./layouts/UnauthLayout/UnauthLayout";

import ErrorBoundary from './ErrorBoundary'

import InviteCode, {inviteCodePath} from "./routes/authGroup/InviteCode";
import AddCard, {path as addCardPath} from "./routes/authGroup/AddCard";
import Login from "./routes/authGroup/Login";
import Signup from "./routes/authGroup/Signup";
import ResetPassword from "./routes/authGroup/ResetPassword";

import Home from './routes/Home'
import EmailTemplatesRoutes from './routes/firstLevelRoutes/EmailTemplates'
import FlowRoutes from  './routes/firstLevelRoutes/Flow'
import VisitorsRoutes from './routes/firstLevelRoutes/Visitors'
import visitorsPathname from './routes/firstLevelRoutes/Visitors/pathname'
import NotFoundRoute from  './routes/NotFound'
import SettingsRoutes from  './routes/Settings'
import ConnectGaRoute, { connectPath } from './routes/Connect'

// import StyleGuideRoutes from  './routes/StyleGuide'

import appStyles from './App.scss'

import '!style-loader!css-loader!react-toastify/dist/ReactToastify.min.css';

class App extends React.PureComponent {
  constructor({ getUser }) {
    super()

    getUser();
  }

  render() {
    return (
      <ErrorBoundary>
        <ReactTooltip effect="solid" place="bottom"/>
        <ToastContainer/>

        <ConnectedRouter history={history}>
          <Router history={history}>
            <div className={appStyles.rootWrapper}>
              <Switch>
                <UnauthLayoutRoute exact path={inviteCodePath} component={InviteCode} />
                <UnauthLayoutRoute exact path={addCardPath} component={AddCard} />
                <UnauthLayoutRoute exact path="/login" component={Login} />
                <UnauthLayoutRoute exact path="/signup" component={Signup} />
                <UnauthLayoutRoute exact path="/restore/:token" component={ResetPassword} />

                <MainLayoutRoute exact path="/" component={Home} />
                <MainLayoutRoute path="/email-templates" component={EmailTemplatesRoutes} />
                <MainLayoutRoute path="/flows" component={FlowRoutes} />
                <MainLayoutRoute path={visitorsPathname} component={VisitorsRoutes} />
                <MainLayoutRoute path={connectPath} component={ConnectGaRoute} />
                {/*<MainLayoutRoute exact path="/contacts/:id?" component={ContactsRoutes} />*/}
                <MainLayoutRoute path="/settings" component={SettingsRoutes} />

                {/*<MainLayoutRoute path="/style-guide" component={StyleGuideRoutes} />*/}

                <MainLayoutRoute component={NotFoundRoute} /> {/* 404 */}
              </Switch>
            </div>
          </Router>
        </ConnectedRouter>
      </ErrorBoundary>
    );
  }
}

export default connect(null, {getUser})(App)
